module.exports = __webpack_public_path__ + "static/media/3lol1.0e0740f5.png";